import './App.css';

import ChartContainer from './components/Chart/ChartContainer';

function App() {
  return (
    <div className="page__container">
        <ChartContainer />
    </div>
  );
}

export default App;